import {usePlayers} from '@glark-newco/game-library';
import {Stack} from '@mantine/core';
import {useCallback, useEffect} from 'react';
import {AssignNodePopup} from './AssignNodePopup';
import {AvatarEditActions} from './AvatarEditActions';
import {ChatAndPlayerListPanel} from './ChatAndPlayerListPanel';
import {CustomiseAvatar} from './CustomiseAvatar';
import {DesignModeOptions} from './DesignModeOptions';
import {ExpandingButton} from './ExpandingButton';
import {GameRulesButton} from './GameRulesPanel';
import {InitialNetworkPopup} from './InitialNetworkPopup';
import {AvatarInterface, AvatarOptions} from '../hooks/useCreateAvatar';
import {useNetworkNodes} from '../state/networkHooks';
import {PositionNode} from '../state/networkStore';
import {usePlayerAvatar} from '../state/PlayerAvatarSlice';
import {useDesignActive, useDraftAvatar, useInitialNetworkMade, useSetDesignActive, useSetDraftAvatar} from '../state/uiStore';

function DesignModeOverlay() {
    const nodes = useNetworkNodes();

    return (<>
        <DesignModeOptions/>
        {Object.entries(nodes).map(([id, node]: [id: string, val: PositionNode]) => {
            return <AssignNodePopup
                key={`user_edit_${node.x * node.y}`}
                nodeId={parseInt(id)}
                x={node.x}
                y={node.y}/>;
        })}
    </>);
}

export function LobbyOverlay() {
    const designActive = useDesignActive();
    const setDesignActive = useSetDesignActive();

    const localEditAvatar = useDraftAvatar();
    const setLocalEditAvatar = useSetDraftAvatar(); // Can change, not published
    const {localPlayer} = usePlayers();
    const currentAvatar = usePlayerAvatar(localPlayer.playerId);
    const initialNetworkSelectionMade = useInitialNetworkMade();

    const handleAvatarChange = useCallback((property: AvatarOptions, value: number) => {
        const a: AvatarInterface = {...localEditAvatar};
        a[property] = value;
        setLocalEditAvatar({...a});
    }, [localEditAvatar, setLocalEditAvatar]);

    useEffect(() => {
        setLocalEditAvatar(currentAvatar); // When event found avatar changes, update avatar
    }, [currentAvatar]);

    return (
        <>
            {localPlayer.isFacilitator && (
                <Stack style={{position: 'absolute', top: '0%', right: '21.7%'}} gap={'0.3em'}>
                    <ExpandingButton
                        active={!designActive}
                        onClick={() => setDesignActive(false)}   // lobby view
                        icon='images/globe.svg'
                        label='Lobby'
                        expandDirection='LEFT'
                    />
                    <ExpandingButton
                        active={designActive}
                        onClick={() => setDesignActive(true)}    // design view
                        icon='images/design.svg'
                        label='Design'
                        expandDirection='LEFT'
                    />
                </Stack>
            )}

            {!designActive ? (
                <>
                    <CustomiseAvatar handleChange={handleAvatarChange} avatar={localEditAvatar}/>
                    <AvatarEditActions currentAvatar={currentAvatar} temporaryAvatar={localEditAvatar}
                        setTemporaryAvatar={setLocalEditAvatar}/>
                </>
            ) : (
                <>
                    {initialNetworkSelectionMade && <DesignModeOverlay/>}
                    {!initialNetworkSelectionMade && <InitialNetworkPopup/>}
                </>
            )}
            <GameRulesButton />
            <ChatAndPlayerListPanel/>
        </>
    );
}
